import styled from "styled-components/macro";

// TODO make a sticky navbar
export const StyledMainContainer = styled.div`
  width: 100%;
`;
export const StyledInnerContainer = styled.div`
  width: 100%;
  margin: auto;
  padding: 0 4px;
  max-width: 1200px;
  min-width: 850px;
`;
